import { render, staticRenderFns } from "./HUBAccountItem.vue?vue&type=template&id=5b56c8b0&scoped=true&"
import script from "./HUBAccountItem.vue?vue&type=script&lang=js&"
export * from "./HUBAccountItem.vue?vue&type=script&lang=js&"
import style0 from "./HUBAccountItem.vue?vue&type=style&index=0&id=5b56c8b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56c8b0",
  null
  
)

export default component.exports